import AnimalProfile from "./AnimalProfile";

export default AnimalProfile;
